import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './auth/services/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }

  constructor(private http: HttpClient, private appConfig: AppConfigService,) { }

  getConfig(): Observable<any> {
    return this.http.get(
      `${this.appConfig.config.baseUrl}${this.appConfig.config.backendUrl}/pois/config`,
    {observe: 'response'}
    ).pipe(
      catchError(this.handleError)
    );
  }

}
